import { Link } from "react-router-dom";
import { siteName, mainSiteUrl } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-base" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteName}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              An independent resource hub for Basetao Spreadsheet product research, QC guidance,
              shipping information and buyer guides.
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              Explore
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  Basetao Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/how-to-use-basetao-spreadsheet" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  How to Use the Spreadsheet
                </Link>
              </li>
              <li>
                <Link to="/basetao-review" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  Basetao Review
                </Link>
              </li>
              <li>
                <Link to="/basetao-shipping-cost" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  Shipping Cost Guide
                </Link>
              </li>
              <li>
                <Link to="/basetao-buyer-guide" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  Complete Buyer Guide
                </Link>
              </li>
            </ul>
          </div>

          {/* Visit */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              Visit Main Website
            </h4>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              Continue your product research and explore the full Basetao Spreadsheet on the main
              website.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              Explore Basetao Spreadsheet
              <i className="ri-arrow-right-up-line text-sm" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-100 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteName}. All rights reserved.
          </p>
          <p className="max-w-md text-xs leading-relaxed text-foreground-500">
            {siteName} is an independent information and research resource. It is not the official
            Basetao website. Always verify current information before purchasing.
          </p>
        </div>
      </div>
    </footer>
  );
}